import { useEffect, useState } from "react";
import { Typography, Box, Grid, Container, Divider } from "src/components";
import { useAuth } from 'src/utils';
import HandbookHeader from './handbook-header';
import BookmarksPreview from './bookmarks-preview';
import { handbookGroups } from 'src/data';
import CategoryCard from './category-card';

export default function Handbook(props) {
  const { user } = useAuth();

  const [bookmarkIds, setBookmarkIds] = useState(user !== null ? user.bookmarks : []);

  useEffect(() => {
    if (user === null) {
      setBookmarkIds([]);
      return;
    }
    setBookmarkIds(user.bookmarks ? user.bookmarks : []);
  }, [user]);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        minHeight: '100%',
        background: '#FAFAFA',
        overflowY: 'auto', 
        width: '100%',
        pb: 8
      }}
    >
      <HandbookHeader 
          title={"PanAm Highway Handbook"} 
          description={"Your comprehensive guide to Pan Am operations, procedures, and best practices. Select a category below to access detailed information and guidelines"}/>

      <Container maxWidth="lg" sx={{ pb: 4 }}>

        <BookmarksPreview bookmarkIds={bookmarkIds} setHandbookMenuTab={props.setHandbookMenuTab}/>

        {handbookGroups.map((group, i) => (
          <Box key={i} sx={{ mb: 5 }}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              {group.title}
            </Typography>

            <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
              {group.categories.map((category) => (
                <Grid size={4} key={category.slug}>
                  <CategoryCard category={category} groupColor={group.color} />
                </Grid>
              ))}
            </Grid>
            <Divider sx={{mt: 3}}/>
          </Box>
        ))}

      </Container>
    </Box>
  );
}